import {SlideBase} from './SlideBase';
import {SlideProps} from './tipos';

export function SlideBoasVindas({vertical}: SlideProps) {
	return (
		<SlideBase vertical={vertical}>
			<div className="slide-boasvindas">
				<span className="slide-boasvindas-emoji" aria-hidden="true">👋</span>
				<h1>Oi! Que bom<br/>ter você aqui.</h1>
				<p>Precisa do boleto? Toque na tela, digite seu CPF ou CNPJ e pronto: imprime ou paga com PIX em segundos.</p>
				<div className="slide-boasvindas-passos">
					<div><span className="slide-passo-numero">1</span>Toque na tela</div>
					<div><span className="slide-passo-numero">2</span>Digite seu CPF</div>
					<div><span className="slide-passo-numero">3</span>Imprima ou pague</div>
				</div>
			</div>
		</SlideBase>
	);
}
